/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {useThemeMode} from '../../../_metronic/partials'
import {getCSS, getCSSVariableValue} from '../../../_metronic/assets/ts/_utils'
import {title} from 'process'
// import {getCSS, getCSSVariableValue} from '../../../assets/ts/_utils'
// import {useThemeMode} from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  title: string
  className: string
  x: any
  y: any
  name: string
}

const VideoViews: React.FC<Props> = ({title, className, x, y, name}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const {mode} = useThemeMode()
  const refreshMode = () => {
    if (!chartRef.current || !x || !y) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))
    const chart = new ApexCharts(chartRef.current, getChartOptions(height, x, y, name))

    chart.render()
    return chart
  }

  useEffect(() => {
    if (!x || !y) return

    const chart = refreshMode()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, x, y])

  if (!x || !y) {
    return <div>Loading chart...</div>
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{title}</span>
        </h3>

        {/* begin::Toolbar */}

        {/* end::Toolbar */}
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Chart */}
        <div ref={chartRef} id='kt_charts_widget_3_chart' style={{height: '350px'}}></div>
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {VideoViews}

function getChartOptions(height: number, x: any, y: any, name: string): any {
  const labelColor = getCSSVariableValue('--kt-gray-500')
  const borderColor = getCSSVariableValue('--kt-gray-200')
  const baseColor = getCSSVariableValue('--kt-info')
  const lightColor = getCSSVariableValue('--kt-info-light')

  const maxRecords = 10
  const data = y
  const categories = x

  const step = Math.ceil(data?.length / maxRecords)

  function groupData(subscribers: any, groups: number) {
    const totalDays = subscribers.length;
    const interval = Math.ceil(totalDays / groups); // Determine interval size
    const groupedData = [];
  
    for (let i = 0; i < totalDays; i += interval) {
      const chunk = subscribers.slice(i, i + interval);
      const sum = chunk.reduce((acc:any, item:any) => acc + item.count, 0); // Sum counts in the group
      groupedData.push({
        date: chunk[chunk.length - 1]?.date || chunk[0]?.date, // Use last date in range
        count: sum,
      });
    }
  
    return groupedData;
  }
  
  
  

  

  const groupedSubscribers = groupData(y.map((count:any, i:any) => ({ date: x[i], count })), 10);
  let displayedData = groupedSubscribers.map((e) => e.count);
  let displayedCategories = groupedSubscribers.map((e) => e.date);

  return {
    series: [
      {
        name: name,
        data: displayedData,
      },
      //
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: 350,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    plotOptions: {},
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      opacity: 1,
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [baseColor],
    },

    xaxis: {
      categories: displayedCategories,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      tooltip: {
        enabled: true,
        formatter: undefined,
        offsetY: 0,
        style: {
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val: any) {
          return val
        },
      },
    },
    colors: [lightColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    markers: {
      strokeColors: baseColor,
      strokeWidth: 3,
    },
  }
}
